<script>

  export default {
    props: {
      breadcrumbs: {
        type: Array,
        default: () => []
      }
    }
  }
</script>

<template>
  <div class="bread-crumbs border-b border-gray-200">
    <div class="container px-4 md:px-8">
      <ul class="flex flex-wrap py-2">
        <li>
          <nuxt-link
            to="/"
            class="text-gray-500 hover:text-gray-600 default-transition text-sm"
          >
            Home
          </nuxt-link>
        </li>
        <li
          v-for="crumb in breadcrumbs"
          :key="crumb.slug"
        >
          <nuxt-link
            :to="crumb.slug"
            class="text-gray-500 hover:text-gray-600 default-transition text-sm"
          >
            {{ crumb.title }}
          </nuxt-link>
        </li>
      </ul>
    </div>
  </div>
</template>

<style lang="scss">
.bread-crumbs {
  ul {
    li:not(:last-child) {
      &:after {
        content: "/";
        @apply text-gray-500 text-sm px-2;
      }
    }

    .nuxt-link-exact-active {
      @apply text-gray-600;
    }
  }
}
</style>
